module.exports = __webpack_public_path__ + "static/media/Logo-QL-White-Cyan.e9cf1557.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/Logo-QL-White-Cyan.svg
// module id = 244
// module chunks = 0